import { useEffect } from "react";
import { useAuth } from "../../context/AuthContext";
import { isNative } from "../../native/capacitor";
import { registerPush } from "../../native/pushRegister";
import { initPushListeners } from "../../native/pushListeners";
import { enableWebPush, webPushSupported } from "../../native/webPush";

// يُعيد تسجيل توكن الإشعارات بصمت بعد كل دخول (التوكن يتغيّر/يُفقد بعد التحديثات)،
// وذلك فقط إذا كان الإذن ممنوحاً مسبقاً — بلا أي طلب إذن مزعج.
export const PushSync = () => {
  const { user } = useAuth();
  const userId = user?.id;
  useEffect(() => {
    if (!userId) return;
    if (isNative()) {
      registerPush().catch(() => {});
      initPushListeners().catch(() => {});
      return;
    }
    if (webPushSupported() && Notification.permission === "granted") {
      enableWebPush().catch(() => {});
    }
  }, [userId]);
  return null;
};
